<script lang="ts">
  import LoadingCogsTheme from './loading-cogs-theme.svelte';
  import { LoadingThemeType } from '../../../enums/themes/loading-theme-type.enum';
  import { ConfigStore } from '../../../store/config';
  import LoadingAtomThem from './loading-atom-them.svelte';
  import LoadingWaveThem from './loading-wave-them.svelte';
  import LoadingGooeyTheme from './loading-gooey-theme.svelte';
  import LoadingStickyTheme from './loading-sticky-theme.svelte';
  import { onDestroy, onMount } from 'svelte';
  import LoadingWithTextTheme from './loading-with-text-theme.svelte';

  const messages = [
    'Processing request',
    'Gathering knowledge',
    'Analyzing data',
    'Generating response',
  ];

  let messageIndex = 0;
  let currentMessage = messages[messageIndex];
  let intervalId: number | undefined;

  function updateText() {
    messageIndex = (messageIndex + 1) % messages.length;
    currentMessage = messages[messageIndex];
  }

  onMount(() => {
    intervalId = setInterval(updateText, 2000);
  });

  onDestroy(() => {
    clearInterval(intervalId);
  });
</script>

{#if $ConfigStore.customTheme?.loadingThemeType === LoadingThemeType.atom}
  <LoadingAtomThem />
{:else if $ConfigStore.customTheme?.loadingThemeType === LoadingThemeType.cogs}
  <LoadingCogsTheme />
{:else if $ConfigStore.customTheme?.loadingThemeType === LoadingThemeType.wave}
  <LoadingWaveThem />
{:else if $ConfigStore.customTheme?.loadingThemeType === LoadingThemeType.gooey}
  <LoadingGooeyTheme />
{:else if $ConfigStore.customTheme?.loadingThemeType === LoadingThemeType.sticky}
  <LoadingStickyTheme />
{:else if $ConfigStore.customTheme?.loadingThemeType === LoadingThemeType.withText}
  <LoadingWithTextTheme />
{/if}
{#if $ConfigStore.customTheme?.loadingThemeType === LoadingThemeType.atom || $ConfigStore.customTheme?.loadingThemeType === LoadingThemeType.cogs}
  <div class="cs-cb-text-animation">
    <div class="dynamic-text-wrapper">
      <span id="dynamicTextContent">{currentMessage}</span>
      <span class="wave-dot">.</span>
      <span class="wave-dot">.</span>
      <span class="wave-dot">.</span>
    </div>
  </div>
{/if}

<style lang="scss">
  @use './../../../../scss/components/themes/loading-theme/loading-theme';
</style>
